import { useCampaignEffectivenessStore } from "@/stores/CampaignEffectivenessStore";

export const CampaignEffectivenessStores = [useCampaignEffectivenessStore];

export const CampaignEffectivenessChannel = {
  async received(payload) {
    // Export completion (success or error) is handled by the shared export
    // manager, which downloads the standardized `payload.data.files`.
    this.campaignEffectivenessStore.handleExportMessage(payload);
  },
};
